import React from 'react';
import PropTypes from 'prop-types';

const Headline = ({ iconSrc, alt, title, children, style }) => {
     return (
          <div className='headline-wrapper'>
               <div className='d-flex headline-title'>
                    {iconSrc && <img className='listener-icon-headline' src={iconSrc} alt={alt || 'icon'} />}
                    <h1 style={style}>{title}</h1>
               </div>
               {children && (
                    <div className='description'>
                         {children}
                    </div>
               )}
          </div>
     );
};


Headline.propTypes = {
     children: PropTypes.node,
     iconSrc: PropTypes.any,
     alt: PropTypes.string,
     title: PropTypes.string,
     style: PropTypes.any,
};

export default Headline;
